import React, { FunctionComponent } from 'react';
import { Colors, Theme, AnalyticsComponent } from '@inplayer-org/inplayer-ui';
import styled, { StyledComponent } from 'styled-components';

// styled components
import { ThinTypography } from './BoxItem';

const Block: StyledComponent<'div', Theme> = styled.div`
  min-height: 10vh;
  border: 1px solid ${Colors.gray};
  box-sizing: border-box;
  border-radius: 3px;
  position: relative;
  transition: all 200ms ease-in-out;
  height: 100%;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  padding: 0.5rem;
  cursor: pointer;
`;

const AddNewTypography = styled(ThinTypography)`
  color: ${({ theme }) => theme.palette.text.main};
  text-align: center;
`;

const AddNewIcon = styled.span`
  font-weight: 100;
  font-size: ${({ theme }) => theme.font.sizes.extraLarge};
  color: ${({ theme }) => theme.palette.text.main};
  transition: color 0.2s ease-in-out;
`;

const AddNewBlock = styled(Block)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &:hover {
    background: ${Colors.white};

    ${ThinTypography}, ${AddNewIcon} {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

interface OwnProps {
  itemTitle: string;
  handleAddNew: (event: any) => void;
}

const BoxItemAdder: FunctionComponent<OwnProps> = ({ itemTitle, handleAddNew }) => {
  return (
    <AnalyticsComponent>
      {({ pages, tracker, merchantId, ip }) => (
        <AddNewBlock
          onClick={(e: any) => {
            handleAddNew(e);
            tracker.track({
              event: 'click',
              type: 'box',
              tag: 'box_new',
              pages,
              merchantId,
              ip,
            });
          }}
        >
          <AddNewIcon>+</AddNewIcon>
          <AddNewTypography variant="p">New {itemTitle}</AddNewTypography>
        </AddNewBlock>
      )}
    </AnalyticsComponent>
  );
};

export default BoxItemAdder;
